import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API, refreshSession } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const checkAuth = useCallback(async () => {
    const me = () => axios.get(`${API}/auth/me`).then((r) => setUser(r.data));
    try {
      await me();
    } catch {
      try {
        await refreshSession();
        await me();
      } catch {
        setUser(false);
      }
    }
  }, []);

  useEffect(() => {
    // Returning from Google OAuth: AuthCallback exchanges the session first
    if (window.location.hash?.includes("session_id=")) return;
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    await axios.post(`${API}/auth/logout`).catch(() => {});
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, logout, refreshUser: checkAuth }}>{children}</AuthContext.Provider>;
};
